import { WMS1020_R01LotDto } from 'src/containers/mes/WMS/WMS1020_R01/Dto_WMS1020_R01';

/** 포장량 기준 LOT별 입고량 배열 (마지막 요소는 나머지) */
export function computePackQtyLotAmounts(totalQty: number, packQty: number): number[] {
	const total = Number(totalQty) || 0;
	const pack = Number(packQty) || 0;

	if (total <= 0) {
		return [];
	}

	if (pack <= 0) {
		return [total];
	}

	const fullCount = Math.floor(total / pack);
	const remainder = total % pack;
	const amounts: number[] = [];

	for (let i = 0; i < fullCount; i++) {
		amounts.push(pack);
	}

	if (remainder > 0) {
		amounts.push(remainder);
	}

	return amounts;
}

/** 주문잔량을 포장량 단위로 분할한 LOT 행 목록 생성 */
export function buildLotsByPackQty(
	totalQty: number,
	packQty: number,
	baseLot: WMS1020_R01LotDto,
	startValueIndex = 1,
): WMS1020_R01LotDto[] {
	const amounts = computePackQtyLotAmounts(totalQty, packQty);

	return amounts.map((lotQty, index) => ({
		...baseLot,
		valueIndex: startValueIndex + index,
		orderIndex: startValueIndex + index,
		orderIndexSeq: 0,
		lotQty,
		inserted: true,
		isModified: false,
	}));
}
